import InApp from 'detect-inapp';
const inapp = new InApp(navigator.userAgent || navigator.vendor || window.opera);
export default class PlatformUtil {
    static isIOS() {
        return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    }
    static isAndroid() {
        return this.userAgentHas(/android/i);
    }
    static isApp() {
        return window.ReactNativeWebView !== undefined;
    }
    static isInAppBrowser() {
        return !this.isApp() && (inapp.isInApp || this.userAgentHas(/SamsungBrowser/));
    }
    static isMobile() {
        return this.userAgentHas(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
    }
    static isDesktop() {
        return !PlatformUtil.isMobile();
    }
    static isSafari() {
        return !this.userAgentHas(/chrome/i) && this.userAgentHas(/safari/i);
    }
    static userAgentHas(regexp) {
        return !!navigator.userAgent && regexp.test(navigator.userAgent);
    }
    static hasFlippedImageBug() {
        // `toDataURL` API generates an upside down image on Safari with versions older than 15:
        // * https://trac.webkit.org/changeset/279424/webkit/
        // * https://webkit.org/blog/11951/release-notes-for-safari-technology-preview-129/
        // * https://webkit.org/blog/11989/new-webkit-features-in-safari-15/
        if (this.isSafari()) {
            const r = /Version\/(\d+).(\d+)/.exec(navigator.userAgent);
            if (r && parseInt(r[1], 10) >= 15) {
                return false;
            }
            return true;
        }
        return false;
    }
}
